import state from './servicedivision.state'
import mutations from './servicedivision.mutations'
import actions from './servicedivision.actions'

export default {
  state,
  mutations,
  actions
}
